import type { JobAdsFetch } from "@/modules/jobAds/client/hooks/useJobAdsFetch"
import type { FunctionComponent, PropsWithChildren } from "react"

import { createContext, useMemo } from "react"

export type JobAdsFetchProviderProps = PropsWithChildren<{
  jobAdsFetchHook: () => JobAdsFetch
}>

export const JobAdsFetchContext = createContext<JobAdsFetchProviderProps | undefined>(undefined)

export const JobAdsFetchProvider: FunctionComponent<JobAdsFetchProviderProps> = ({ jobAdsFetchHook, children }) => {
  const value = useMemo(
    () => ({
      jobAdsFetchHook,
    }),
    [jobAdsFetchHook]
  )

  return <JobAdsFetchContext.Provider value={value}>{children}</JobAdsFetchContext.Provider>
}
